<template>
  <div>
    <dashboard-header :text="$t('ui.detailGroup')" :on-back="onGoBack"/>

    <div class="d-flex align-content-center justify-content-center">
      <v-card
          elevation="0"
          :loading="loading"
          class="card-border-10 mx-16 w-75">
        <div class="pa-5">
          <data-detail
              data-colon
              :items="items"
              :headers="tableHeaders"
          />
        </div>
      </v-card>
    </div>

  </div>
</template>

<script>
import {API2} from "../../api";
import DataDetail from "../base/DataDetail.vue";
import i18n from "../../lang/i18n";
import mixin from "../../mixin";
import DashboardHeader from "../component/DashboardHeader";

export default {
  components: {DashboardHeader, DataDetail},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
    item: {
      type: Object,
    }
  },
  data() {
    return {
      detail: null,
    };
  },
  mounted() {
    this.onTab(this.item);
  },
  computed: {
    header() {
      return this.item ? this.item.name : ''
    },
    tableHeaders() {
      return [
        {key: 'title', label: this.$t('base.title'), thStyle: {width: '50%'}},
        {key: 'data', label: this.$t('base.content')}
      ]
    },
    items() {
      return [
        {
          title: i18n.t("ui.nameGroup"),
          data: this.detail ? this.shortenText(this.detail.name, 30) : ''
        },
        {
          title: i18n.t("ui.numberSchedules"),
          data: this.item ? (this.item.data.scheduleCount || 0) : ''
        },
        {
          title: i18n.t("base.createdAt"),
          data: this.detail ? this.formatDate(this.detail.createdAt) : ''
        },
        {
          title: i18n.t("base.updatedAt"),
          data: this.detail ? this.formatDate(this.detail.updatedAt) : ''
        },
      ]
    },

  },
  methods: {
    onTab(item) {
      if (item) this.getData(item)
    },
    async getData(item) {
      this.detail = null
      let res = await this.get(API2.GROUP, {path: item.data.groupId})
      if (res) {
        this.detail = res;
      } else {
        this.onGoBack(); // Go back to list screen
      }
    },
    onGoBack() {
      this.openTab(0)
    },
    shortenText(text, maxLength) {
      return text.length > maxLength ? text.substring(0, maxLength) + "…" : text;
    },
  }
};
</script>

<style scoped>
.info {
  color: #595959;
}
</style>
